const translations = {
  en: {
    nav: {
      properties: 'Properties',
      guides: 'Guides',
      blog: 'Blog',
      favorites: 'Favorites',
      dashboard: 'Dashboard',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
    },
    home: {
      hero_title: 'Find Your Dream Property',
      hero_subtitle: 'Sell & Buy Property Without Estate Agent Fees',
      search_placeholder: 'Search by property name, city...',
      featured: 'Featured Properties',
      how_it_works: 'How It Works',
      get_started: 'Get Started',
    },
    property: {
      for_sale: 'For Sale',
      for_rent: 'For Rent',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      sqft: 'Sq Ft',
      views: 'views',
      view_details: 'View Details',
      share: 'Share',
      book_viewing: 'Book Viewing',
      verify_legal: 'Verify & Legal',
      all_properties: 'All Properties',
    },
    auth: {
      email: 'Email',
      password: 'Password',
      confirm_password: 'Confirm Password',
      name: 'Full Name',
      phone: 'Phone Number',
      sign_in: 'Sign In',
      sign_up: 'Sign Up',
      forgot_password: 'Forgot Password?',
      no_account: "Don't have an account?",
      have_account: 'Already have an account?',
    },
    deal: {
      deal_tracker: 'Deal Tracker',
      upload_document: 'Upload Document',
      cancel_deal: 'Cancel Deal',
      documents: 'Documents',
      milestones: 'Milestones',
      create_deal: 'Create Deal',
      no_deals: 'No deals yet',
    },
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      search: 'Search',
      filters: 'Filters',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      close: 'Close',
    },
  },
  hi: {
    nav: {
      properties: 'प्रॉपर्टी',
      guides: 'गाइड',
      blog: 'ब्लॉग',
      favorites: 'पसंदीदा',
      dashboard: 'डैशबोर्ड',
      login: 'लॉगिन',
      register: 'रजिस्टर',
      logout: 'लॉगआउट',
    },
    home: {
      hero_title: 'अपना सपनों का घर खोजें',
      hero_subtitle: 'एस्टेट एजेंट फीस के बिना प्रॉपर्टी खरीदें और बेचें',
      search_placeholder: 'प्रॉपर्टी नाम, शहर से खोजें...',
      featured: 'फीचर्ड प्रॉपर्टी',
      how_it_works: 'यह कैसे काम करता है',
      get_started: 'शुरू करें',
    },
    property: {
      for_sale: 'बिक्री के लिए',
      for_rent: 'किराए के लिए',
      bedrooms: 'बेडरूम',
      bathrooms: 'बाथरूम',
      sqft: 'वर्ग फुट',
      views: 'बार देखा गया',
      view_details: 'विवरण देखें',
      share: 'शेयर करें',
      book_viewing: 'विजिट बुक करें',
      verify_legal: 'सत्यापन और कानूनी',
      all_properties: 'सभी प्रॉपर्टी',
    },
    auth: {
      email: 'ईमेल',
      password: 'पासवर्ड',
      confirm_password: 'पासवर्ड पुष्टि',
      name: 'पूरा नाम',
      phone: 'फ़ोन नंबर',
      sign_in: 'साइन इन',
      sign_up: 'साइन अप',
      forgot_password: 'पासवर्ड भूल गए?',
      no_account: 'खाता नहीं है?',
      have_account: 'पहले से खाता है?',
    },
    deal: {
      deal_tracker: 'डील ट्रैकर',
      upload_document: 'दस्तावेज़ अपलोड',
      cancel_deal: 'डील रद्द करें',
      documents: 'दस्तावेज़',
      milestones: 'माइलस्टोन',
      create_deal: 'डील बनाएं',
      no_deals: 'अभी कोई डील नहीं',
    },
    common: {
      loading: 'लोड हो रहा है...',
      save: 'सेव करें',
      cancel: 'रद्द करें',
      delete: 'हटाएं',
      search: 'खोजें',
      filters: 'फ़िल्टर',
      back: 'वापस',
      next: 'अगला',
      submit: 'जमा करें',
      close: 'बंद करें',
    },
  },
  fr: {
    nav: {
      properties: 'Propriétés',
      guides: 'Guides',
      blog: 'Blog',
      favorites: 'Favoris',
      dashboard: 'Tableau de bord',
      login: 'Connexion',
      register: "S'inscrire",
      logout: 'Déconnexion',
    },
    home: {
      hero_title: 'Trouvez Votre Propriété de Rêve',
      hero_subtitle: "Achetez et vendez sans frais d'agent immobilier",
      search_placeholder: 'Rechercher par nom, ville...',
      featured: 'Propriétés en Vedette',
      how_it_works: 'Comment Ça Marche',
      get_started: 'Commencer',
    },
    property: {
      for_sale: 'À Vendre',
      for_rent: 'À Louer',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      sqft: 'Pi²',
      views: 'vues',
      view_details: 'Voir les détails',
      share: 'Partager',
      book_viewing: 'Réserver une visite',
      verify_legal: 'Vérification légale',
      all_properties: 'Toutes les propriétés',
    },
    auth: {
      email: 'Courriel',
      password: 'Mot de passe',
      confirm_password: 'Confirmer le mot de passe',
      name: 'Nom complet',
      phone: 'Téléphone',
      sign_in: 'Se connecter',
      sign_up: "S'inscrire",
      forgot_password: 'Mot de passe oublié?',
      no_account: "Pas de compte?",
      have_account: 'Déjà un compte?',
    },
    deal: {
      deal_tracker: 'Suivi des transactions',
      upload_document: 'Télécharger un document',
      cancel_deal: 'Annuler la transaction',
      documents: 'Documents',
      milestones: 'Étapes',
      create_deal: 'Créer une transaction',
      no_deals: 'Aucune transaction',
    },
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      search: 'Rechercher',
      filters: 'Filtres',
      back: 'Retour',
      next: 'Suivant',
      submit: 'Soumettre',
      close: 'Fermer',
    },
  },
};

export default translations;
